/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Principal {
  STSAccessKeyID?: string;
  STSSecretAccessKey?: string;
  STSSessionToken?: string;
  accountAccessKey?: string;
  hm?: boolean;
  ob?: boolean;
  customStyleOb?: string;
  token?: string;
}

export interface ApiError {
  /** @format int32 */
  code?: number;
  message: string;
  detailedMessage: string;
}

export interface LoginDetail {
  loginStrategy?:
    | "form"
    | "redirect"
    | "service-account"
    | "redirect-service-account";
  redirectRules?: RedirectRule[];
  isK8S?: boolean;
  navigateFrom?: string;
}

export interface LoginDetails {
  loginDetail?: LoginDetail[];
}

export interface LoginRequest {
  accessKey?: string;
  secretKey?: string;
  sts?: string;
  mfa_token?: string;
  otp?: string;
  features?: {
    hide_menu?: boolean;
  };
}

export interface LoginOauth2AuthRequest {
  state: string;
  code: string;
}

export interface LoginResponse {
  access_token?: string;
  mfa_token?: string;
}

export interface LogoutRequest {
  state?: string;
}

export interface LicenseRequest {
  jwt?: string;
}

export interface LicenseResponse {
  /** @format int64 */
  valid_until: number;
}

export interface SessionResponse {
  status?: "ok";
}

export interface RedirectRule {
  redirect?: string;
  displayName?: string;
}

export interface SetupConfig {
  jwt?: string;
  ui_endpoint?: string;
  api_endpoint?: string;
  /** @format int32 */
  api_port?: number;
  email?: string;
  password?: string;
}

export interface User {
  id: string;
  email: string;
  name: string;
  lastName: string;
  roles: string[];
  sys_created?: string;
}

export type Id = string;

export interface PoolDetails {
  /** @format int64 */
  total_drives_per_set?: number;
  /** @format int64 */
  total_sets?: number;
}

export interface MinioDeploymentDetails {
  id: string;
  name: string;
  url: string;
  access_key: string;
  /** @format int64 */
  sys_created: number;
  pools?: PoolDetails[];
  services?: {
    observe?: Observe[];
    catalog?: Catalog[];
  };
}

export interface CreateDeployment {
  id: string;
  name: string;
  url: string;
  access_key: string;
  secret_key: string;
  console_url?: string;
  observe_url?: string;
  catalog_url?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface Observe {
  url?: string;
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface Catalog {
  url?: string;
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sys_created?: number;
}

export enum Status {
  Online = "online",
  Offline = "offline",
}

export interface Site {
  id?: string;
  name?: string;
  /** @format int64 */
  sys_created?: number;
  setup_type?:
    | "kubernetes"
    | "aks"
    | "eks"
    | "gke"
    | "ocp"
    | "tanzu"
    | "baremetal";
  status?: Status;
  resources?: {
    tenants?: Tenant[];
    observes?: Observe[];
    catalogs?: Catalog[];
    keyManagers?: KeyManager[];
    firewalls?: Firewall[];
    operator?: Operator;
    directPV?: DirectPV;
    ingresses?: Ingress[];
  };
}

export interface KeyManager {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface Firewall {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface Ingress {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sys_created?: number;
}

export interface Pool {
  /** @format int32 */
  num_servers?: number;
  /** @format int32 */
  drives_per_server?: number;
  drive_size?: number;
}

export interface Tenant {
  id?: string;
  name?: string;
  namespace?: string;
  pools?: Pool[];
  capacity?: number;
  usage?: number;
  raw_capacity?: number;
  raw_usage?: number;
  /** @format int64 */
  sys_created?: number;
  status?: Status;
}

export interface AddSite {
  name?: string;
}

export interface AddResource {
  name?: string;
  resource_type?: "minio" | "observe" | "catalog" | "key-manager";
  url?: string;
  arguments?: Record<string, string>;
}

export interface Operator {
  version?: string;
  enterprise_version?: string;
  namespace?: string;
}

export interface DirectPV {
  version?: string;
}

export interface JoinPSK {
  psk?: string;
  api_endpoint?: string;
  ca_hash?: string;
}

export interface JoinSite {
  psk?: string;
  api_endpoint?: string;
  ca_hash?: string;
  site_name?: string;
}

export interface Error {
  /** @format int32 */
  code?: number;
  message: string;
  detailedMessage: string;
}

export interface OpTenantStatus {
  /** @format int32 */
  write_quorum?: number;
  /** @format int32 */
  drives_online?: number;
  /** @format int32 */
  drives_offline?: number;
  /** @format int32 */
  drives_healing?: number;
  health_status?: string;
  usage?: {
    /** @format int64 */
    raw?: number;
    /** @format int64 */
    raw_usage?: number;
    /** @format int64 */
    capacity?: number;
    /** @format int64 */
    capacity_usage?: number;
  };
}

export interface OpTenantConfigurationResponse {
  environmentVariables?: OpEnvironmentVariable[];
  sftpExposed?: boolean;
}

export interface OpUpdateTenantConfigurationRequest {
  keysToBeDeleted?: string[];
  environmentVariables?: OpEnvironmentVariable[];
  sftpExposed?: boolean;
}

export interface OpTenantSecurityResponse {
  autoCert?: boolean;
  customCertificates?: {
    minio?: OpCertificateInfo[];
    client?: OpCertificateInfo[];
    minioCAs?: OpCertificateInfo[];
  };
  securityContext?: OpSecurityContext;
}

export interface UpdateTenantSecurityRequest {
  autoCert?: boolean;
  customCertificates?: {
    secretsToBeDeleted?: string[];
    minioServerCertificates?: KeyPairConfiguration[];
    minioClientCertificates?: KeyPairConfiguration[];
    minioCAsCertificates?: string[];
  };
  securityContext?: OpSecurityContext;
}

export interface OpCertificateInfo {
  serialNumber?: string;
  name?: string;
  domains?: string[];
  expiry?: string;
}

export interface OpTenant {
  name?: string;
  creation_date?: string;
  deletion_date?: string;
  currentState?: string;
  pools?: OpPool[];
  image?: string;
  namespace?: string;
  /** @format int64 */
  total_size?: number;
  subnet_license?: OpLicense;
  endpoints?: {
    minio?: string;
    console?: string;
  };
  idpAdEnabled?: boolean;
  idpOidcEnabled?: boolean;
  encryptionEnabled?: boolean;
  status?: OpTenantStatus;
  minioTLS?: boolean;
  domains?: OpDomainsConfiguration;
  tiers?: TenantTierElement[];
  sftpExposed?: boolean;
}

export interface TenantUsage {
  /** @format int64 */
  used?: number;
  /** @format int64 */
  disk_used?: number;
}

export interface TenantList {
  name?: string;
  pool_count?: number;
  instance_count?: number;
  total_size?: number;
  volume_count?: number;
  creation_date?: string;
  deletion_date?: string;
  currentState?: string;
  namespace?: string;
  health_status?: string;
  /** @format int64 */
  capacity_raw?: number;
  /** @format int64 */
  capacity_raw_usage?: number;
  /** @format int64 */
  capacity?: number;
  /** @format int64 */
  capacity_usage?: number;
  tiers?: TenantTierElement[];
  domains?: OpDomainsConfiguration;
}

export interface ListTenantsResponse {
  /** list of resulting tenants */
  tenants?: TenantList[];
  /**
   * number of tenants accessible to tenant user
   * @format int64
   */
  total?: number;
}

export interface UpdateTenantRequest {
  /** @pattern ^((.*?)/(.*?):(.+))$ */
  image?: string;
  image_registry?: ImageRegistry;
  image_pull_secret?: string;
  sftpExposed?: boolean;
}

export interface ImageRegistry {
  registry: string;
  username: string;
  password: string;
}

export interface MetadataFields {
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  node_selector?: Record<string, string>;
}

export interface KeyPairConfiguration {
  crt: string;
  key: string;
}

export interface TlsConfiguration {
  minioServerCertificates?: KeyPairConfiguration[];
  minioClientCertificates?: KeyPairConfiguration[];
  minioCAsCertificates?: string[];
}

export interface SetAdministratorsRequest {
  user_dns?: string[];
  group_dns?: string[];
}

export interface OpIdpConfiguration {
  oidc?: {
    configuration_url: string;
    client_id: string;
    secret_id: string;
    callback_url?: string;
    claim_name: string;
    scopes?: string;
  };
  keys?: {
    access_key: string;
    secret_key: string;
  }[];
  active_directory?: {
    url: string;
    group_search_base_dn?: string;
    group_search_filter?: string;
    skip_tls_verification?: boolean;
    server_insecure?: boolean;
    server_start_tls?: boolean;
    lookup_bind_dn: string;
    lookup_bind_password?: string;
    user_dn_search_base_dn?: string;
    user_dn_search_filter?: string;
    user_dns?: string[];
  };
}

export type OpEncryptionConfiguration = MetadataFields & {
  raw?: string;
  image?: string;
  replicas?: string;
  secretsToBeDeleted?: string[];
  server_tls?: KeyPairConfiguration;
  minio_mtls?: KeyPairConfiguration;
  kms_mtls?: {
    key?: string;
    crt?: string;
    ca?: string;
  };
  policies?: object;
  gemalto?: GemaltoConfiguration;
  aws?: AwsConfiguration;
  vault?: VaultConfiguration;
  gcp?: GcpConfiguration;
  azure?: AzureConfiguration;
  securityContext?: OpSecurityContext;
};

export type OpEncryptionConfigurationResponse = MetadataFields & {
  raw?: string;
  policies?: object;
  image?: string;
  replicas?: string;
  server_tls?: OpCertificateInfo;
  minio_mtls?: OpCertificateInfo;
  kms_mtls?: {
    crt?: OpCertificateInfo;
    ca?: OpCertificateInfo;
  };
  gemalto?: GemaltoConfigurationResponse;
  aws?: AwsConfiguration;
  vault?: VaultConfigurationResponse;
  gcp?: GcpConfiguration;
  azure?: AzureConfiguration;
  securityContext?: OpSecurityContext;
};

export interface VaultConfiguration {
  endpoint: string;
  engine?: string;
  namespace?: string;
  prefix?: string;
  approle: {
    engine?: string;
    id: string;
    secret: string;
    /** @format int64 */
    retry?: number;
  };
  status?: {
    /** @format int64 */
    ping?: number;
  };
}

export interface VaultConfigurationResponse {
  endpoint: string;
  engine?: string;
  namespace?: string;
  prefix?: string;
  approle: {
    engine?: string;
    id: string;
    secret: string;
    /** @format int64 */
    retry?: number;
  };
  status?: {
    /** @format int64 */
    ping?: number;
  };
}

export interface AwsConfiguration {
  secretsmanager: {
    endpoint: string;
    region: string;
    kmskey?: string;
    credentials: {
      accesskey: string;
      secretkey: string;
      token?: string;
    };
  };
}

export interface GemaltoConfiguration {
  keysecure: {
    endpoint: string;
    credentials: {
      token: string;
      domain: string;
      /** @format int64 */
      retry?: number;
    };
  };
}

export interface GemaltoConfigurationResponse {
  keysecure: {
    endpoint: string;
    credentials: {
      token: string;
      domain: string;
      /** @format int64 */
      retry?: number;
    };
  };
}

export interface GcpConfiguration {
  secretmanager: {
    project_id: string;
    endpoint?: string;
    credentials?: {
      client_email?: string;
      client_id?: string;
      private_key_id?: string;
      private_key?: string;
    };
  };
}

export interface AzureConfiguration {
  keyvault: {
    endpoint: string;
    credentials?: {
      tenant_id: string;
      client_id: string;
      client_secret: string;
    };
  };
}

export interface CreateTenantResponse {
  externalIDP?: boolean;
  console?: TenantResponseItem[];
}

export interface TenantResponseItem {
  access_key?: string;
  secret_key?: string;
  url?: string;
}

export interface OpPool {
  name?: string;
  servers: number;
  /** @format int32 */
  volumes_per_server: number;
  volume_configuration: {
    size: number;
    storage_class_name?: string;
    labels?: Record<string, string>;
    annotations?: Record<string, string>;
  };
  /** If provided, use these requests and limit for cpu/memory resource allocation */
  resources?: OpPoolResources;
  /** NodeSelector is a selector which must be true for the pod to fit on a node. Selector which must match a node's labels for the pod to be scheduled on that node. More info: https://kubernetes.io/docs/concepts/configuration/assign-pod-node/ */
  node_selector?: Record<string, string>;
  /** If specified, affinity will define the pod's scheduling constraints */
  affinity?: OpPoolAffinity;
  runtimeClassName?: string;
  /** Tolerations allows users to set entries like effect, key, operator, value. */
  tolerations?: OpPoolTolerations;
  securityContext?: OpSecurityContext;
}

/** Tolerations allows users to set entries like effect, key, operator, value. */
export type OpPoolTolerations = {
  /** Effect indicates the taint effect to match. Empty means match all taint effects. When specified, allowed values are NoSchedule, PreferNoSchedule and NoExecute. */
  effect?: string;
  /** Key is the taint key that the toleration applies to. Empty means match all taint keys. If the key is empty, operator must be Exists; this combination means to match all values and all keys. */
  key?: string;
  /** Operator represents a key's relationship to the value. Valid operators are Exists and Equal. Defaults to Equal. Exists is equivalent to wildcard for value, so that a pod can tolerate all taints of a particular category. */
  operator?: string;
  /** TolerationSeconds represents the period of time the toleration (which must be of effect NoExecute, otherwise this field is ignored) tolerates the taint. By default, it is not set, which means tolerate the taint forever (do not evict). Zero and negative values will be treated as 0 (evict immediately) by the system. */
  tolerationSeconds?: PoolTolerationSeconds;
  /** Value is the taint value the toleration matches to. If the operator is Exists, the value should be empty, otherwise just a regular string. */
  value?: string;
}[];

/** TolerationSeconds represents the period of time the toleration (which must be of effect NoExecute, otherwise this field is ignored) tolerates the taint. By default, it is not set, which means tolerate the taint forever (do not evict). Zero and negative values will be treated as 0 (evict immediately) by the system. */
export interface PoolTolerationSeconds {
  /** @format int64 */
  seconds: number;
}

/** If provided, use these requests and limit for cpu/memory resource allocation */
export interface OpPoolResources {
  /** Limits describes the maximum amount of compute resources allowed. More info: https://kubernetes.io/docs/concepts/configuration/manage-compute-resources-container/ */
  limits?: Record<string, number>;
  /** Requests describes the minimum amount of compute resources required. If Requests is omitted for a container, it defaults to Limits if that is explicitly specified, otherwise to an implementation-defined value. More info: https://kubernetes.io/docs/concepts/configuration/manage-compute-resources-container/ */
  requests?: Record<string, number>;
}

/** If specified, affinity will define the pod's scheduling constraints */
export interface OpPoolAffinity {
  /** Describes node affinity scheduling rules for the pod. */
  nodeAffinity?: {
    /** The scheduler will prefer to schedule pods to nodes that satisfy the affinity expressions specified by this field, but it may choose a node that violates one or more of the expressions. The node that is most preferred is the one with the greatest sum of weights, i.e. for each node that meets all of the scheduling requirements (resource request, requiredDuringScheduling affinity expressions, etc.), compute a sum by iterating through the elements of this field and adding "weight" to the sum if the node matches the corresponding matchExpressions; the node(s) with the highest sum are the most preferred. */
    preferredDuringSchedulingIgnoredDuringExecution?: {
      /** A node selector term, associated with the corresponding weight. */
      preference: NodeSelectorTerm;
      /**
       * Weight associated with matching the corresponding nodeSelectorTerm, in the range 1-100.
       * @format int32
       */
      weight: number;
    }[];
    /** If the affinity requirements specified by this field are not met at scheduling time, the pod will not be scheduled onto the node. If the affinity requirements specified by this field cease to be met at some point during pod execution (e.g. due to an update), the system may or may not try to eventually evict the pod from its node. */
    requiredDuringSchedulingIgnoredDuringExecution?: {
      /** Required. A list of node selector terms. The terms are ORed. */
      nodeSelectorTerms: NodeSelectorTerm[];
    };
  };
  /** Describes pod affinity scheduling rules (e.g. co-locate this pod in the same node, pool, etc. as some other pod(s)). */
  podAffinity?: {
    /** The scheduler will prefer to schedule pods to nodes that satisfy the affinity expressions specified by this field, but it may choose a node that violates one or more of the expressions. The node that is most preferred is the one with the greatest sum of weights, i.e. for each node that meets all of the scheduling requirements (resource request, requiredDuringScheduling affinity expressions, etc.), compute a sum by iterating through the elements of this field and adding "weight" to the sum if the node has pods which matches the corresponding podAffinityTerm; the node(s) with the highest sum are the most preferred. */
    preferredDuringSchedulingIgnoredDuringExecution?: {
      /** Required. A pod affinity term, associated with the corresponding weight. */
      podAffinityTerm: PodAffinityTerm;
      /**
       * weight associated with matching the corresponding podAffinityTerm, in the range 1-100.
       * @format int32
       */
      weight: number;
    }[];
    /** If the affinity requirements specified by this field are not met at scheduling time, the pod will not be scheduled onto the node. If the affinity requirements specified by this field cease to be met at some point during pod execution (e.g. due to a pod label update), the system may or may not try to eventually evict the pod from its node. When there are multiple elements, the lists of nodes corresponding to each podAffinityTerm are intersected, i.e. all terms must be satisfied. */
    requiredDuringSchedulingIgnoredDuringExecution?: PodAffinityTerm[];
  };
  /** Describes pod anti-affinity scheduling rules (e.g. avoid putting this pod in the same node, pool, etc. as some other pod(s)). */
  podAntiAffinity?: {
    /** The scheduler will prefer to schedule pods to nodes that satisfy the anti-affinity expressions specified by this field, but it may choose a node that violates one or more of the expressions. The node that is most preferred is the one with the greatest sum of weights, i.e. for each node that meets all of the scheduling requirements (resource request, requiredDuringScheduling anti-affinity expressions, etc.), compute a sum by iterating through the elements of this field and adding "weight" to the sum if the node has pods which matches the corresponding podAffinityTerm; the node(s) with the highest sum are the most preferred. */
    preferredDuringSchedulingIgnoredDuringExecution?: {
      /** Required. A pod affinity term, associated with the corresponding weight. */
      podAffinityTerm: PodAffinityTerm;
      /**
       * weight associated with matching the corresponding podAffinityTerm, in the range 1-100.
       * @format int32
       */
      weight: number;
    }[];
    /** If the anti-affinity requirements specified by this field are not met at scheduling time, the pod will not be scheduled onto the node. If the anti-affinity requirements specified by this field cease to be met at some point during pod execution (e.g. due to a pod label update), the system may or may not try to eventually evict the pod from its node. When there are multiple elements, the lists of nodes corresponding to each podAffinityTerm are intersected, i.e. all terms must be satisfied. */
    requiredDuringSchedulingIgnoredDuringExecution?: PodAffinityTerm[];
  };
}

/** A null or empty node selector term matches no objects. The requirements of them are ANDed. The TopologySelectorTerm type implements a subset of the NodeSelectorTerm. */
export interface NodeSelectorTerm {
  /** A list of node selector requirements by node's labels. */
  matchExpressions?: {
    /** The label key that the selector applies to. */
    key: string;
    /** Represents a key's relationship to a set of values. Valid operators are In, NotIn, Exists, DoesNotExist. Gt, and Lt. */
    operator: string;
    /** An array of string values. If the operator is In or NotIn, the values array must be non-empty. If the operator is Exists or DoesNotExist, the values array must be empty. If the operator is Gt or Lt, the values array must have a single element, which will be interpreted as an integer. This array is replaced during a strategic merge patch. */
    values?: string[];
  }[];
  /** A list of node selector requirements by node's fields. */
  matchFields?: {
    /** The label key that the selector applies to. */
    key: string;
    /** Represents a key's relationship to a set of values. Valid operators are In, NotIn, Exists, DoesNotExist. Gt, and Lt. */
    operator: string;
    /** An array of string values. If the operator is In or NotIn, the values array must be non-empty. If the operator is Exists or DoesNotExist, the values array must be empty. If the operator is Gt or Lt, the values array must have a single element, which will be interpreted as an integer. This array is replaced during a strategic merge patch. */
    values?: string[];
  }[];
}

/** Required. A pod affinity term, associated with the corresponding weight. */
export interface PodAffinityTerm {
  /** A label query over a set of resources, in this case pods. */
  labelSelector?: {
    /** matchExpressions is a list of label selector requirements. The requirements are ANDed. */
    matchExpressions?: {
      /** key is the label key that the selector applies to. */
      key: string;
      /** operator represents a key's relationship to a set of values. Valid operators are In, NotIn, Exists and DoesNotExist. */
      operator: string;
      /** values is an array of string values. If the operator is In or NotIn, the values array must be non-empty. If the operator is Exists or DoesNotExist, the values array must be empty. This array is replaced during a strategic merge patch. */
      values?: string[];
    }[];
    /** matchLabels is a map of {key,value} pairs. A single {key,value} in the matchLabels map is equivalent to an element of matchExpressions, whose key field is "key", the operator is "In", and the values array contains only "value". The requirements are ANDed. */
    matchLabels?: Record<string, string>;
  };
  /** namespaces specifies which namespaces the labelSelector applies to (matches against); null or empty list means "this pod's namespace" */
  namespaces?: string[];
  /** This pod should be co-located (affinity) or not co-located (anti-affinity) with the pods matching the labelSelector in the specified namespaces, where co-located is defined as running on a node whose value of the label with key topologyKey matches that of any node on which any of the selected pods is running. Empty topologyKey is not allowed. */
  topologyKey: string;
}

export interface OpResourceQuota {
  name?: string;
  elements?: OpResourceQuotaElement[];
}

export interface OpResourceQuotaElement {
  name?: string;
  /** @format int64 */
  hard?: number;
  /** @format int64 */
  used?: number;
}

export type ParityResponse = string[];

export interface ListPVCsResponse {
  pvcs?: PvcsListResponse[];
}

export interface PvcsListResponse {
  namespace?: string;
  name?: string;
  status?: string;
  volume?: string;
  tenant?: string;
  capacity?: string;
  storageClass?: string;
  age?: string;
}

export type NodeLabels = Record<string, string[]>;

export interface Namespace {
  name: string;
}

export interface DescribePodWrapper {
  name?: string;
  namespace?: string;
  priority?: number;
  priorityClassName?: string;
  nodeName?: string;
  startTime?: string;
  labels?: Label[];
  annotations?: Annotation[];
  deletionTimestamp?: string;
  deletionGracePeriodSeconds?: number;
  phase?: string;
  reason?: string;
  message?: string;
  podIP?: string;
  controllerRef?: string;
  containers?: Container[];
  conditions?: Condition[];
  volumes?: Volume[];
  qosClass?: string;
  nodeSelector?: NodeSelector[];
  tolerations?: Toleration[];
}

export interface Container {
  name?: string;
  containerID?: string;
  image?: string;
  imageID?: string;
  ports?: string[];
  hostPorts?: string[];
  args?: string[];
  state?: State;
  lastState?: State;
  ready?: boolean;
  restartCount?: number;
  environmentVariables?: OpEnvironmentVariable[];
  mounts?: Mount[];
}

export interface State {
  state?: string;
  reason?: string;
  message?: string;
  exitCode?: number;
  started?: string;
  finished?: string;
  signal?: number;
}

export interface OpEnvironmentVariable {
  key?: string;
  value?: string;
}

export interface Mount {
  mountPath?: string;
  name?: string;
  readOnly?: boolean;
  subPath?: string;
}

export interface Condition {
  type?: string;
  status?: string;
}

export interface Volume {
  name?: string;
  pvc?: Pvc;
  projected?: ProjectedVolume;
}

export interface Pvc {
  claimName?: string;
  readOnly?: boolean;
}

export interface ProjectedVolume {
  sources?: ProjectedVolumeSource[];
}

export interface ProjectedVolumeSource {
  secret?: Secret;
  downwardApi?: boolean;
  configMap?: ConfigMap;
  serviceAccountToken?: ServiceAccountToken;
}

export interface Secret {
  name?: string;
  optional?: boolean;
}

export interface ConfigMap {
  name?: string;
  optional?: boolean;
}

export interface ServiceAccountToken {
  expirationSeconds?: number;
}

export interface Toleration {
  tolerationSeconds?: number;
  key?: string;
  value?: string;
  effect?: string;
  operator?: string;
}

export interface Label {
  key?: string;
  value?: string;
}

export interface Annotation {
  key?: string;
  value?: string;
}

export interface NodeSelector {
  key?: string;
  value?: string;
}

export interface OpSecurityContext {
  runAsUser: string;
  runAsGroup: string;
  runAsNonRoot: boolean;
  fsGroup?: string;
  fsGroupChangePolicy?: string;
}

export interface CheckOperatorVersionResponse {
  current_version?: string;
  latest_version?: string;
}

export interface TenantTierElement {
  name?: string;
  type?: string;
  /** @format int64 */
  size?: number;
}

export interface OpDomainsConfiguration {
  minio?: string[];
  console?: string;
}

export interface MpIntegration {
  email?: string;
  isInEU?: boolean;
}

export interface OperatorRedirectRule {
  redirect?: string;
  displayName?: string;
}

/** @default "user" */
export enum PolicyEntity {
  User = "user",
  Group = "group",
}

export interface ServerDrives {
  uuid?: string;
  state?: string;
  endpoint?: string;
  drivePath?: string;
  rootDisk?: boolean;
  healing?: boolean;
  model?: string;
  totalSpace?: number;
  usedSpace?: number;
  availableSpace?: number;
}

export interface ServerProperties {
  state?: string;
  endpoint?: string;
  uptime?: number;
  version?: string;
  commitID?: string;
  poolNumber?: number;
  network?: Record<string, string>;
  drives?: ServerDrives[];
}

export interface BackendProperties {
  backendType?: string;
  rrSCParity?: number;
  standardSCParity?: number;
}

export interface TenantLogReport {
  filename?: string;
  blob?: string;
}

export interface TenantYAML {
  yaml?: string;
}

export interface OpLicense {
  email?: string;
  organization?: string;
  account_id?: number;
  storage_capacity?: number;
  plan?: string;
  expires_at?: string;
}

export interface InstallOperator {
  namespace?: string;
  namespaces_to_watch?: string;
  images?: {
    operator_image?: string;
    enterprise_image?: string;
    kes_image?: string;
    minio_image?: string;
  };
  cluster_domain?: string;
  registry?: RegistryCredentials;
}

export interface RegistryCredentials {
  username?: string;
  password?: string;
  registry_url?: string;
}

export interface Users {
  /** @format int64 */
  count?: number;
  results: User[];
}

export interface AddUserRequest {
  password: string;
  email: string;
  name?: string;
  lastName?: string;
  roles: string[];
}

export interface EditUserRequest {
  password?: string;
  email?: string;
  name?: string;
  lastName?: string;
  roles?: string[];
}

export interface UserDetails {
  email: string;
  id: string;
  name: string;
  lastName: string;
  roles: Role[];
}

export interface ListRolesResponse {
  results: Role[];
}

export interface ListDefaultRolesResponse {
  results: GetRoleResponse[];
}

export interface Role {
  name: string;
  id: string;
  isAdmin: boolean;
}

export interface CreateRoleRequest {
  name: string;
  isAdmin: boolean;
  rules: Rule[];
}

export interface Rule {
  sites: string[];
  resources: string[];
  namespaces: string[];
  resourceNames: string[];
  actions: string[];
}

export interface GetRoleResponse {
  name: string;
  id: string;
  isAdmin: boolean;
  rules: Rule[];
}

export interface CreateIdentityProviderRequest {
  name: string;
  url: string;
  logout: string;
  clientID: string;
  secret: string;
  callbackDynamic: boolean;
  scopes: string;
}

export interface ListIdentityProvidersResponse {
  results: IdentityProvider[];
}

export interface IdentityProvider {
  id: string;
  name: string;
  url: string;
  logout: string;
  clientID: string;
  secret: string;
  callbackDynamic: boolean;
  scopes: string;
}

export interface GetIdentityProviderResponse {
  id: string;
  name: string;
  url: string;
  logout: string;
  clientID: string;
  secret: string;
  callbackDynamic: boolean;
  scopes: string;
}

export interface ListResourcesResponse {
  results: string[];
}

export interface ListActionsResponse {
  results: string[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MinIO Mission Control
 * @version 0.1.0
 * @baseUrl /api/v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  login = {
    /**
     * No description
     *
     * @tags Auth
     * @name LoginDetail
     * @summary Returns login strategy, form or sso.
     * @request GET:/login
     */
    loginDetail: (params: RequestParams = {}) =>
      this.request<LoginDetails, ApiError>({
        path: `/login`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name Login
     * @summary Login to MinIO Mission Control
     * @request POST:/login
     */
    login: (body: LoginRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, ApiError>({
        path: `/login`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name LoginOauth2Auth
     * @summary Identity Provider oauth2 callback endpoint.
     * @request POST:/login/oauth2/auth
     */
    loginOauth2Auth: (
      body: LoginOauth2AuthRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, Error>({
        path: `/login/oauth2/auth`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  logout = {
    /**
     * No description
     *
     * @tags Auth
     * @name Logout
     * @summary Logout from Operator.
     * @request POST:/logout
     * @secure
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/logout`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  session = {
    /**
     * No description
     *
     * @tags Auth
     * @name SessionCheck
     * @summary Endpoint to check if your session is still valid
     * @request GET:/session
     * @secure
     */
    sessionCheck: (params: RequestParams = {}) =>
      this.request<SessionResponse, ApiError>({
        path: `/session`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name Delete
     * @summary Logout endpont
     * @request DELETE:/session
     * @secure
     */
    delete: (params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/session`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  license = {
    /**
     * No description
     *
     * @tags License
     * @name License
     * @summary Check license status
     * @request GET:/license
     */
    license: (params: RequestParams = {}) =>
      this.request<LicenseResponse, ApiError>({
        path: `/license`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name SetLicense
     * @summary Set License
     * @request POST:/license
     * @secure
     */
    setLicense: (body: LicenseRequest, params: RequestParams = {}) =>
      this.request<LicenseResponse, ApiError>({
        path: `/license`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags License
     * @name LicenseValidate
     * @summary Validate License
     * @request POST:/license/validate
     * @secure
     */
    licenseValidate: (body: LicenseRequest, params: RequestParams = {}) =>
      this.request<LicenseResponse, ApiError>({
        path: `/license/validate`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  setup = {
    /**
     * No description
     *
     * @tags Setup
     * @name SetupConfig
     * @summary Gets any pre-existing config
     * @request GET:/setup/config
     */
    setupConfig: (params: RequestParams = {}) =>
      this.request<SetupConfig, ApiError>({
        path: `/setup/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name SetSetupConfig
     * @summary Set Setup Config
     * @request POST:/setup/config
     */
    setSetupConfig: (body: SetupConfig, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/setup/config`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name SetupJoin
     * @summary Join an existing cluster
     * @request POST:/setup/join
     */
    setupJoin: (body: JoinSite, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/setup/join`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name SetupCheckLicense
     * @summary Check license status
     * @request GET:/setup/license
     */
    setupCheckLicense: (params: RequestParams = {}) =>
      this.request<LicenseResponse, ApiError>({
        path: `/setup/license`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setup
     * @name SetupLicenseValidate
     * @summary Validate License
     * @request POST:/setup/license/validate
     */
    setupLicenseValidate: (body: LicenseRequest, params: RequestParams = {}) =>
      this.request<LicenseResponse, ApiError>({
        path: `/setup/license/validate`,
        method: "POST",
        body: body,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags User
     * @name UsersList
     * @summary List Users
     * @request GET:/users
     * @secure
     */
    usersList: (
      query?: {
        /**
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * @format int64
         * @default 20
         */
        limit?: number;
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Users, ApiError>({
        path: `/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersAdd
     * @summary Add User
     * @request POST:/users
     * @secure
     */
    usersAdd: (body: AddUserRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/users`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserDetails
     * @summary User Details
     * @request GET:/users/{userID}
     * @secure
     */
    userDetails: (userId: string, params: RequestParams = {}) =>
      this.request<UserDetails, ApiError>({
        path: `/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserDelete
     * @summary Delete User
     * @request DELETE:/users/{userID}
     * @secure
     */
    userDelete: (userId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/users/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UserEdit
     * @summary Update User
     * @request PATCH:/users/{userID}
     * @secure
     */
    userEdit: (
      userId: string,
      body: EditUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/users/${userId}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  joinPsk = {
    /**
     * No description
     *
     * @tags Site
     * @name JoinPsk
     * @summary Request PSK to add site
     * @request POST:/join-psk
     */
    joinPsk: (params: RequestParams = {}) =>
      this.request<JoinPSK, ApiError>({
        path: `/join-psk`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  sites = {
    /**
     * No description
     *
     * @tags Site
     * @name SitesAdd
     * @summary Add Bare Metal Site
     * @request POST:/sites
     * @secure
     */
    sitesAdd: (body: AddSite, params: RequestParams = {}) =>
      this.request<Site, ApiError>({
        path: `/sites`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteDetails
     * @summary Site Details
     * @request GET:/sites/{siteID}
     * @secure
     */
    siteDetails: (siteId: string, params: RequestParams = {}) =>
      this.request<Site, ApiError>({
        path: `/sites/${siteId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteEdit
     * @summary Update Site
     * @request PUT:/sites/{siteID}
     * @secure
     */
    siteEdit: (siteId: string, body: Site, params: RequestParams = {}) =>
      this.request<Site, ApiError>({
        path: `/sites/${siteId}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteDelete
     * @summary Delete Site
     * @request DELETE:/sites/{siteID}
     * @secure
     */
    siteDelete: (siteId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteOperatorInstall
     * @summary Install Enterprise Operator
     * @request POST:/sites/{siteID}/operator/install
     * @secure
     */
    siteOperatorInstall: (
      siteId: string,
      body: InstallOperator,
      params: RequestParams = {},
    ) =>
      this.request<Operator, ApiError>({
        path: `/sites/${siteId}/operator/install`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteOperatorUpgrade
     * @summary Upgrades from Operator to Enterprise Operator
     * @request POST:/sites/{siteID}/operator/upgrade
     * @secure
     */
    siteOperatorUpgrade: (
      siteId: string,
      body: InstallOperator,
      params: RequestParams = {},
    ) =>
      this.request<Operator, ApiError>({
        path: `/sites/${siteId}/operator/upgrade`,
        method: "POST",
        body: body,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Site
     * @name SiteResourceAdd
     * @summary Add Site Resource
     * @request POST:/sites/{siteID}/resources
     * @secure
     */
    siteResourceAdd: (
      siteId: string,
      body: AddResource,
      params: RequestParams = {},
    ) =>
      this.request<Site, ApiError>({
        path: `/sites/${siteId}/resources`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name ListAllTenants
     * @summary List Tenant of All Namespaces
     * @request GET:/sites/{siteID}/tenants
     * @secure
     */
    listAllTenants: (
      siteId: string,
      query?: {
        sort_by?: string;
        /**
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * @format int64
         * @default 20
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListTenantsResponse, ApiError>({
        path: `/sites/${siteId}/tenants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name CreateNamespace
     * @summary Creates a new Namespace with given information
     * @request POST:/sites/{siteID}/namespace
     * @secure
     */
    createNamespace: (
      siteId: string,
      body: Namespace,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespace`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantIdentityProvider
     * @summary Tenant Identity Provider
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/identity-provider
     * @secure
     */
    tenantIdentityProvider: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<OpIdpConfiguration, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/identity-provider`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name UpdateTenantIdentityProvider
     * @summary Update Tenant Identity Provider
     * @request POST:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/identity-provider
     * @secure
     */
    updateTenantIdentityProvider: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: OpIdpConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/identity-provider`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name SetTenantAdministrators
     * @summary Set the consoleAdmin policy to the specified users and groups
     * @request POST:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/set-administrators
     * @secure
     */
    setTenantAdministrators: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: SetAdministratorsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/set-administrators`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantConfiguration
     * @summary Tenant Configuration
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/configuration
     * @secure
     */
    tenantConfiguration: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<OpTenantConfigurationResponse, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name UpdateTenantConfiguration
     * @summary Update Tenant Configuration
     * @request PATCH:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/configuration
     * @secure
     */
    updateTenantConfiguration: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: OpUpdateTenantConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/configuration`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantSecurity
     * @summary Tenant Security
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/security
     * @secure
     */
    tenantSecurity: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<OpTenantSecurityResponse, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/security`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name UpdateTenantSecurity
     * @summary Update Tenant Security.
     * @request POST:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/security
     * @secure
     */
    updateTenantSecurity: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: UpdateTenantSecurityRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/security`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name ListPvCsForTenant
     * @summary List all PVCs from given Tenant
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/pvcs
     * @secure
     */
    listPvCsForTenant: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<ListPVCsResponse, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/pvcs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetTenantUsage
     * @summary Get Usage For The Tenant
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/usage
     * @secure
     */
    getTenantUsage: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<TenantUsage, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/usage`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetTenantLogReport
     * @summary Get Tenant Log Report
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/log-report
     * @secure
     */
    getTenantLogReport: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<TenantLogReport, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/log-report`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetPodLogs
     * @summary Get Logs for Pod
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/pods/{podName}/logs
     * @secure
     */
    getPodLogs: (
      siteId: string,
      namespace: string,
      tenant: string,
      podName: string,
      params: RequestParams = {},
    ) =>
      this.request<Id, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/pods/${podName}/logs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name DescribePod
     * @summary Describe Pod
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/pods/{podName}/describe
     * @secure
     */
    describePod: (
      siteId: string,
      namespace: string,
      tenant: string,
      podName: string,
      params: RequestParams = {},
    ) =>
      this.request<DescribePodWrapper, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/pods/${podName}/describe`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantUpdateCertificate
     * @summary Tenant Update Certificates
     * @request PUT:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/certificates
     * @secure
     */
    tenantUpdateCertificate: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: TlsConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/certificates`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantDeleteEncryption
     * @summary Tenant Delete Encryption
     * @request DELETE:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/encryption
     * @secure
     */
    tenantDeleteEncryption: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/encryption`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantUpdateEncryption
     * @summary Tenant Update Encryption
     * @request PUT:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/encryption
     * @secure
     */
    tenantUpdateEncryption: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: OpEncryptionConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/encryption`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name TenantEncryptionInfo
     * @summary Tenant Encryption Info
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/encryption
     * @secure
     */
    tenantEncryptionInfo: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<OpEncryptionConfigurationResponse, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/encryption`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetTenantYaml
     * @summary Get the Tenant YAML
     * @request GET:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/yaml
     * @secure
     */
    getTenantYaml: (
      siteId: string,
      namespace: string,
      tenant: string,
      params: RequestParams = {},
    ) =>
      this.request<TenantYAML, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/yaml`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name PutTenantYaml
     * @summary Put the Tenant YAML
     * @request PUT:/sites/{siteID}/namespaces/{namespace}/tenants/{tenant}/yaml
     * @secure
     */
    putTenantYaml: (
      siteId: string,
      namespace: string,
      tenant: string,
      body: TenantYAML,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/tenants/${tenant}/yaml`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetResourceQuota
     * @summary Get Resource Quota
     * @request GET:/sites/{siteID}/namespaces/{namespace}/resourcequotas/{resourceQuotaName}
     * @secure
     */
    getResourceQuota: (
      siteId: string,
      namespace: string,
      resourceQuotaName: string,
      params: RequestParams = {},
    ) =>
      this.request<OpResourceQuota, ApiError>({
        path: `/sites/${siteId}/namespaces/${namespace}/resourcequotas/${resourceQuotaName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name GetParity
     * @summary Gets parity by sending number of nodes & number of disks
     * @request GET:/sites/{siteID}/get-parity/{nodes}/{disksPerNode}
     * @secure
     */
    getParity: (
      siteId: string,
      nodes: number,
      disksPerNode: number,
      params: RequestParams = {},
    ) =>
      this.request<ParityResponse, ApiError>({
        path: `/sites/${siteId}/get-parity/${nodes}/${disksPerNode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name ListPvCs
     * @summary List all PVCs from namespaces that the user has access to
     * @request GET:/sites/{siteID}/list-pvcs
     * @secure
     */
    listPvCs: (siteId: string, params: RequestParams = {}) =>
      this.request<ListPVCsResponse, ApiError>({
        path: `/sites/${siteId}/list-pvcs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operator
     * @name ListNodeLabels
     * @summary List node labels
     * @request GET:/sites/{siteID}/nodes/labels
     * @secure
     */
    listNodeLabels: (siteId: string, params: RequestParams = {}) =>
      this.request<NodeLabels, ApiError>({
        path: `/sites/${siteId}/nodes/labels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  authorization = {
    /**
     * No description
     *
     * @tags Authorization
     * @name ListResources
     * @summary List all resources
     * @request GET:/authorization/resources
     * @secure
     */
    listResources: (params: RequestParams = {}) =>
      this.request<ListResourcesResponse, ApiError>({
        path: `/authorization/resources`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name ListActions
     * @summary List all actions
     * @request GET:/authorization/actions
     * @secure
     */
    listActions: (params: RequestParams = {}) =>
      this.request<ListActionsResponse, ApiError>({
        path: `/authorization/actions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name ListDefaultRoles
     * @summary List all Default roles
     * @request GET:/authorization/default-roles
     * @secure
     */
    listDefaultRoles: (params: RequestParams = {}) =>
      this.request<ListDefaultRolesResponse, ApiError>({
        path: `/authorization/default-roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name ListRoles
     * @summary List all roles
     * @request GET:/authorization/roles
     * @secure
     */
    listRoles: (params: RequestParams = {}) =>
      this.request<ListRolesResponse, ApiError>({
        path: `/authorization/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name CreateRole
     * @summary Create
     * @request POST:/authorization/roles
     * @secure
     */
    createRole: (body: CreateRoleRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/authorization/roles`,
        method: "POST",
        body: body,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name GetRole
     * @summary Get Role Details
     * @request GET:/authorization/roles/{roleID}
     * @secure
     */
    getRole: (roleId: string, params: RequestParams = {}) =>
      this.request<GetRoleResponse, ApiError>({
        path: `/authorization/roles/${roleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name UpdateRole
     * @summary Update Role
     * @request PATCH:/authorization/roles/{roleID}
     * @secure
     */
    updateRole: (
      roleId: string,
      body: CreateRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/authorization/roles/${roleId}`,
        method: "PATCH",
        body: body,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authorization
     * @name DeleteRole
     * @summary Delete Role
     * @request DELETE:/authorization/roles/{roleID}
     * @secure
     */
    deleteRole: (roleId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/authorization/roles/${roleId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  authentication = {
    /**
     * No description
     *
     * @tags Authentication
     * @name ListIdentityProviders
     * @summary List all identity providers
     * @request GET:/authentication/identityProvider
     * @secure
     */
    listIdentityProviders: (params: RequestParams = {}) =>
      this.request<ListIdentityProvidersResponse, ApiError>({
        path: `/authentication/identityProvider`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name CreateIdentityProvider
     * @summary Create
     * @request POST:/authentication/identityProvider
     * @secure
     */
    createIdentityProvider: (
      body: CreateIdentityProviderRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/authentication/identityProvider`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetIdentityProvider
     * @summary Get Identity Provider Details
     * @request GET:/authentication/identityProvider/{id}
     * @secure
     */
    getIdentityProvider: (id: string, params: RequestParams = {}) =>
      this.request<GetIdentityProviderResponse, ApiError>({
        path: `/authentication/identityProvider/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name UpdateIdentityProvider
     * @summary Update Identity Provider
     * @request PATCH:/authentication/identityProvider/{id}
     * @secure
     */
    updateIdentityProvider: (
      id: string,
      body: CreateIdentityProviderRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiError>({
        path: `/authentication/identityProvider/${id}`,
        method: "PATCH",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name DeleteIdentityProvider
     * @summary Delete Identity Provider
     * @request DELETE:/authentication/identityProvider/{id}
     * @secure
     */
    deleteIdentityProvider: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/authentication/identityProvider/${id}`,
        method: "DELETE",
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
